__turbopack_context__.v({
  "default": "iconButton-module-scss-module__wJeaYq__default",
  "ghost": "iconButton-module-scss-module__wJeaYq__ghost",
  "iconButton": "iconButton-module-scss-module__wJeaYq__iconButton",
  "lg": "iconButton-module-scss-module__wJeaYq__lg",
  "md": "iconButton-module-scss-module__wJeaYq__md",
  "sm": "iconButton-module-scss-module__wJeaYq__sm",
  "subtle": "iconButton-module-scss-module__wJeaYq__subtle",
});
